import axios from "axios";
import { showToast } from "../helpers/show.toast";

function handleErrorResponse(error, dispatch) {
  const authError = error.response && error.response.status === 401;


  const manyReqError = error.response && error.response.status === 429;
  const serverError = error.response && error.response.status === 500;



  //handle authError (401)
  if (authError) {
    showToast(
      "Session Timeout!",
      "Your session has expired. Please log in again to continue.",
      "error",
    );

    // get localStorage data if needed
    localStorage.clear();

    setTimeout(() => {
      window.location.reload();
    }, [1000]);
  }

  // handle manyReqError (429)
  if (manyReqError) {
    showToast(
      "Too Many Attempts!",
      "You have made too many requests in a short time. Please try again later.",
      "error",
    );
  }

  // handle serverError (500)
  if (serverError) {
    showToast(
      "Unexpected Error!",
      "Oops! Something went wrong on our server. Please contact support for assistance.",
      "error",
    );
  }

  return Promise.reject(error);
}

function initializeInterceptors(dispatch) {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return handleErrorResponse(error, dispatch);
    },
  );
}

axios.interceptors.request.use(
  (config) => config,
  (error) => {
    return Promise.reject(error);
  },
);

function setToken(token) {
  let headers = {
    Accept: `application/json`,
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  axios.defaults.headers.common = headers;
}

const httpService = {
  setToken,
  // get: axios.get,
  // put: axios.put,
  // post: axios.post,
  // patch: axios.patch,
  // delete: axios.delete,
  initializeInterceptors,
  ...axios,
};

export default httpService;
